export default "__VITE_ASSET__DBGzFGP5__"